import Vue from "vue";
import Vuex from "vuex";
import http from "./http";
import da from "element-ui/src/locale/lang/da";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // language: null,
    language: {
      visitor: [],
      home: [],
      staff: []
    },
    visitor: [],
    staff: [],
    sname: null,
    reasons: null,
    area: null,
    department: null,
    // reasons:null,

    code: null,
    msg: null,
    history: [],
    access: [],
    record: [],
    account: [],
    region: {
      regular: [],
      unregular: []
    },
    ticket: [],
    recordInfo: [],
    // ====================================================
    // 后台
    //=====================================================
    user: null,
    // staff: [],
    getRegion: null,
    getInvite: null,
    getInvite_total: 0,

    record_reserve: null,
    record_reserve_total: 0,

    record_staff_pass: null,
    record_staff_pass_total: 0,
    record_visitor_pass: null,
    record_visitor_pass_total: 0,

    getArrive: null,
    getArrive_total: 0,
    system: {
      appid: null
    },
    getPort: [],
    sms_code: null,

    visitor_type: null, // 访客类型
    item_type: null, // 物品类型
    release_reason: null, // 放行原因,

    data_info: [],
    total: 0,

    device: [],

    main_photo: [] // 主图
  },
  mutations: {
    SET_DATA: (state, item) => {
      state.code = item.code;
      state.msg = item.msg;
    },
    SET_HISTORY: (state, item) => {
      state.history = item;
    },
    SET_ACCESS: (state, item) => {
      state.access = item;
    },
    SET_REGION: (state, item) => {
      state.region = item;
    },
    SET_RECORD: (state, item) => {
      state.record = item;
    },
    SET_TICKET: (state, item) => {
      state.ticket = item;
    },
    SET_LANGUAGE: (state, item) => {
      state.language = item;
      // state.language = '3232';
      // console.log(item);
      // console.log(state.language);
      // console.log(state);
    },
    SET_RECORD_INFO: (state, item) => {
      state.recordInfo = item;
    },
    SET_VISITOR_INFO: (state, item) => {
      state.visitor = item;
    },
    SET_STAFF_NAME: (state, item) => {
      state.sname = item;
    },
    SET_STAFF_INFO: (state, item) => {
      state.staff = item;
    },
    // =====================================================
    // 后台
    // =====================================================
    SET_USER: (state, item) => {
      state.user = item;
    },
    SET_STAFF: (state, item) => {
      // 设置被访人信息
      state.staff = item.staff;
      state.total = item.total;
    },
    SET_VISITOR: (state, item) => {
      // 设置被访人信息
      state.visitor = item.visitor;
      state.total = item.total;
    },
    SET_DEPARTMENT: (state, item) => {
      //设置部门信息
      state.department = item.department;
      state.department_total = item.total;
    },
    SET_REASONS: (state, item) => {
      //设置来访事由
      state.reasons = item;
    },
    SET_AREA: (state, item) => {
      //设置来访区域
      state.area = item;
      //   console.log("99");
    },
    SET_VISITOR_TYPE: (state, item) => {
      //设置来访类型
      state.visitor_type = item;
    },
    SET_ITEM_TYPE: (state, item) => {
      //设置物品类型
      state.item_type = item;
      console.log(item);
      console.log("444");
    },
    SET_RELEASE_REASON: (state, item) => {
      //设置放行原因
      state.release_reasons = item;
      console.log(item);
    },
    SET_ACCOUNT: (state, item) => {
      //设置来访事由
      state.account = item;
    },
    SET_RECORD_RESERVE: (state, item) => {
      state.record_reserve = item.record;
      state.record_reserve_total = item.total;
    },

    SET_RECORD_STAFF_PASS: (state, item) => {
      state.record_staff_pass = item.record;
      state.record_staff_pass_total = item.total;
    },
    SET_RECORD_VISITOR_PASS: (state, item) => {
      state.record_visitor_pass = item.record;
      state.record_visitor_pass_total = item.total;
    },

    SET_GET_REGION: (state, item) => {
      state.getRegion = item;
    },
    SET_GET_INVITE: (state, item) => {
      state.getInvite = item.record;
      state.getInvite_total = item.total;
    },
    SET_GET_ARRIVE: (state, item) => {
      state.getArrive = item.record;
      state.getArrive_total = item.total;
    },
    SET_SYSTEM: (state, item) => {
      state.system = item;
    },
    SET_GET_PORT: (state, item) => {
      state.getPort = item;
    },
    SET_SMS_CODE: (state, item) => {
      state.code = item.code;
      state.sms_code = item.sms_code;
    },

    SET_DEVICE: (state, item) => {
      //
      state.device = item;
    },

    /**
     * @date 2022-03-09 16:35
     * 处理后端返回数据，同时也要初始化 data_info 防止 data_info 累积存储其他接口的数据
     **/
    SET_DATA_INFO: (state, item) => {
      // console.log(item)

      const key = item.data.key;
      state.msg = item.msg;
      state.code = item.code;
      state.total = item.data.total;
      state.data_info = [];
      state.data_info[key] = item.data[key];
    },
    SET_MAINPHOTO: (state, item) => {
      //设置主图信息
      state.main_photo = item;
    }
  },
  actions: {
    async lang({ commit }, content) {
      //获取语言信息
      const { data } = await http.lang(content);
      // console.log(data);
      // commit('SET_LANGUAGE', data.data);
      commit("SET_LANGUAGE", data);
    },
    async history({ commit }) {
      //邀请记录
      const { data } = await http.history();
      if (data.code === 0) {
        commit("SET_HISTORY", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async region({ commit }) {
      const { data } = await http.region();
      if (data.code === 0) {
        commit("SET_REGION", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async record({ commit }) {
      const { data } = await http.record();
      if (data.code === 0) {
        commit("SET_RECORD", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },
    // async approval({commit}, content) {
    //     const {data} = await http.approval(content.id, content.status, content.cause);
    //     commit('SET_DATA', data);

    // },
    // async num({commit}, content) {
    //     const {data} = await http.num(content.id, content.num);
    //     commit('SET_DATA', data);
    // },
    async invite({ commit }, content) {
      const { data } = await http.invite(content);
      commit("SET_DATA", data);
    },
    async vpersonal({ commit }, content) {
      //提交访客个人信息
      const { data } = await http.vpersonal(content);
      commit("SET_DATA", data);
      // console.log({data});
      // console.log(33);
      // commit('SET_DATA', data);
    },
    // async getVRecord({ commit }, content) {
    //   //访客获取模板消息记录
    //   const { data } = await http.getVRecord(content);
    //   commit("SET_DATA", data);
    // },

    async getVisitorInfo({ commit }) {
      //获取访客个人信息
      const { data } = await http.getVisitorInfo();
      commit("SET_VISITOR_INFO", data);
    },
    async getStaffName({ commit }, content) {
      //获取被访人姓名
      const { data } = await http.getStaffName(content);
      commit("SET_STAFF_NAME", data);
    },
    async staffRefuse({ commit }, content) {
      //被访人员拒绝预约来访
      const { data } = await http.staffRefuse(content);
      commit("SET_DATA", data);
    },
    async staffAgree({ commit }, content) {
      //被访人员同意预约来访
      const { data } = await http.staffAgree(content);
      commit("SET_DATA", data);
    },
    async leaderRefuse({ commit }, content) {
      //领导拒绝预约来访
      const { data } = await http.leaderRefuse(content);
      commit("SET_DATA", data);
    },
    async leaderAgree({ commit }, content) {
      //领导同意预约来访
      const { data } = await http.leaderAgree(content);
      commit("SET_DATA", data);
    },
    async getStaffRecord({ commit }) {
      //获取员工的预约、邀请记录
      const { data } = await http.getStaffRecord();
      if (data.code === 0) {
        commit("SET_RECORD", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async getVisitorRecord({ commit }) {
      //获取访客预约记录
      const { data } = await http.getVisitorRecord();
      if (data.code === 0) {
        commit("SET_RECORD", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },
    // async getReasons({commit}, content){//获取来访事由
    //     const {data} = await http.getReasons(content);
    //     commit('SET_REASONS', data);
    //     console.log(data);
    //     console.log(123);
    // },
    async vreserve({ commit }, content) {
      //访客发起预约
      const { data } = await http.vreserve(content);
      commit("SET_DATA", data);
    },

    async getStaffInfo({ commit }) {
      //获取被访人个人信息
      const { data } = await http.getStaffInfo();
      commit("SET_STAFF_INFO", data);
    },
    async spersonal({ commit }, content) {
      //被访人员绑定身份
      const { data } = await http.spersonal(content);
      commit("SET_DATA", data);
    },
    async disSpersonal({ commit }, content) {
      //解除绑定
      const { data } = await http.disSpersonal(content);
      commit("SET_DATA", data);
    },
    async getCode({ commit }, content) {
      //获取验证码
      const { data } = await http.getCode(content);
      commit("SET_SMS_CODE", data);
    },
    async getSRecord({ commit }, content) {
      //被访人员获取模板消息记录
      const { data } = await http.getSRecord(content);
      if (data.code === 0) {
        commit("SET_RECORD", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async getLRecord({ commit }, content) {
      //部门领导获取模板消息记录
      const { data } = await http.getLRecord(content);
      if (data.code === 0) {
        commit("SET_RECORD", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async getVRecord({ commit }, content) {
      //访客获取模板消息记录
      const { data } = await http.getVRecord(content);
      if (data.code === 0) {
        commit("SET_RECORD", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async getCRecord({ commit }, content) {
      //抄送人获取模板消息记录
      const { data } = await http.getCRecord(content);
      if (data.code === 0) {
        commit("SET_RECORD", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },

    // ======================================================
    // 后台
    // ======================================================
    async Login({ commit }, content) {
      //登陆后台
      const { data } = await http.Login(content);
      // console.log(data.data);
      if (data.code === 0) {
        commit("SET_USER", data.data);
        console.log(data.data);
      } else {
        commit("SET_DATA", data);
      }
    },
    // ****************
    // 被访人信息 - start
    async staff({ commit }) {
      //获取员工数据
      const { data } = await http.staff();
      if (data.code === 0) {
        commit("SET_STAFF", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async createStaff({ commit }, content) {
      //单个添加员工信息
      const { data } = await http.createStaff(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async deleteStaff({ commit }, content) {
      //单个删除员工信息
      const { data } = await http.deleteStaff(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },

    async faceStaff({ commit }, content) {
      //
      const { data } = await http.faceStaff(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },

    async updateStaff({ commit }, content) {
      //单个修改员工信息
      const { data } = await http.updateStaff(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    // async searchStaff({commit}, content) {//查找指定员工数据
    //   const {data} = await http.searchStaff(content);
    //   if (data.code === 0) {
    //     commit('SET_STAFF', data.data);
    //   } else {
    //     commit('SET_DATA', data);
    //   }
    // },
    async changeLeader({ commit }, content) {
      // 改变被访人是否可以进行访客预约二次审批
      const { data } = await http.changeLeader(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async changeInterview({ commit }, content) {
      // 改变被访人是否可以邀请面试
      const { data } = await http.changeInterview(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async changeReleaseLeader({ commit }, content) {
      //改变被访人是否可以进行放行条审批
      const { data } = await http.changeReleaseLeader(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    // 被访人信息 - end
    // ****************

    async searchVisitor({ commit }, content) {
      //查找指定访客数据
      const { data } = await http.searchVisitor(content);
      if (data.code === 0) {
        commit("SET_VISITOR", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async deleteVisitor({ commit }, content) {
      //单个删除访客信息
      const { data } = await http.deleteVisitor(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },

    // async getDepartment({commit}, content) {//获取部门数据
    //     const {data} = await http.getDepartment(content);
    //     if (data.code === 0) {
    //         commit('SET_DEPARTMENT', data.data);
    //     } else {
    //         commit('SET_DATA', data);
    //     }
    // },
    async createDepartment({ commit }, content) {
      //单个添加部门信息
      const { data } = await http.createDepartment(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async deleteDepartment({ commit }, content) {
      //单个删除部门信息
      const { data } = await http.deleteDepartment(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async updateDepartment({ commit }, content) {
      //单个修改部门信息
      const { data } = await http.updateDepartment(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    // ****************
    // 来访事由 - start
    // async getReasons({commit}) {//获取来访事由
    //     const {data} = await http.getReasons();
    //     console.log(data);
    //     if (data.code === 0) {
    //         commit('SET_REASONS', data.data);
    //         console.log(data);
    //     } else {
    //         commit('SET_DATA', data);
    //     }
    // },
    // async createReasons({commit}, content) {//单个添加来访事由
    //     const {data} = await http.createReasons(content);
    //     if (data.code === 0) {
    //         commit('SET_DATA', data);
    //     } else {
    //         commit('SET_DATA', data);
    //     }
    // },
    // async deleteReasons({commit}, content) {//单个删除来访事由
    //     const {data} = await http.deleteReasons(content);
    //     if (data.code === 0) {
    //         commit('SET_DATA', data);
    //     } else {
    //         commit('SET_DATA', data);
    //     }
    // },
    // async updateReasons({commit}, content) {//单个修改来访事由
    //     const {data} = await http.updateReasons(content);
    //     if (data.code === 0) {
    //         commit('SET_DATA', data);
    //     } else {
    //         commit('SET_DATA', data);
    //     }
    // },
    // 来访事由 - end
    // ****************
    // 拜访厂区 - start
    async getArea3({ commit }, content) {
      //获取拜访厂区
      const { data } = await http.getArea3(content);
      console.log(data);
      if (data.code === 0) {
        commit("SET_DATA_INFO", data);
        console.log(data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async getArea({ commit }, content) {
      //获取拜访厂区
      const { data } = await http.getArea(content);
      //   console.log(data);
      if (data.code === 0) {
        commit("SET_DATA_INFO", data);
        // console.log(data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async createArea({ commit }, content) {
      //单个添加拜访厂区
      const { data } = await http.createArea(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async deleteArea({ commit }, content) {
      //单个删除拜访厂区
      const { data } = await http.deleteArea(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async updateArea({ commit }, content) {
      //单个修改拜访厂区
      const { data } = await http.updateArea(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    // 拜访区域 - end
    // 拜访区域 - start
    async getArea2({ commit }, content) {
      //获取拜访区域
      const { data } = await http.getArea2(content);
      console.log(data);
      if (data.code === 0) {
        commit("SET_DATA_INFO", data);
        console.log(data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async createArea2({ commit }, content) {
      //单个添加拜访区域
      const { data } = await http.createArea2(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async deleteArea2({ commit }, content) {
      //单个删除拜访区域
      const { data } = await http.deleteArea2(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async updateArea2({ commit }, content) {
      //单个修改拜访区域
      const { data } = await http.updateArea2(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    // 拜访区域 - end
    // ****************
    // 访客类型 - start
    async searchVisitorType({ commit }, content) {
      //获取访问类型
      const { data } = await http.searchVisitorType(content);
      // console.log(data);
      if (data.code === 0) {
        // commit("SET_VISITOR_TYPE", data.data);
        commit("SET_DATA_INFO", data);
        // console.log(data);
        // console.log("000000000000000");
        // console.log(data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async createVisitorType({ commit }, content) {
      //单个添加访问类型
      const { data } = await http.createVisitorType(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async deleteVisitorType({ commit }, content) {
      //单个删除访问类型
      const { data } = await http.deleteVisitorType(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async updateVisitorType({ commit }, content) {
      //单个修改访问类型
      const { data } = await http.updateVisitorType(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    // 访客类型 - end
    // ****************
    // 物品类型 - start
    async searchItemType({ commit }, content) {
      //获取访问类型
      const { data } = await http.searchItemType(content);
      if (data.code === 0) {
        commit("SET_DATA_INFO", data);
        console.log(data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async createItemType({ commit }, content) {
      //单个添加访问类型
      const { data } = await http.createItemType(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async deleteItemType({ commit }, content) {
      //单个删除访问类型
      const { data } = await http.deleteItemType(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async updateItemType({ commit }, content) {
      //单个修改访问类型
      const { data } = await http.updateItemType(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    // 物品类型 - end
    // ****************
    // 物品放行的放行类别 - start
    async searchReleaseType({ commit }) {
      //获取放行类别
      const { data } = await http.searchReleaseType();
      console.log(data);
      if (data.code === 0) {
        commit("SET_ITEM_TYPE", data.data);
        console.log(data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async createReleaseType({ commit }, content) {
      //单个添加放行类别
      const { data } = await http.createReleaseType(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async deleteReleaseType({ commit }, content) {
      //单个删除放行类别
      const { data } = await http.deleteReleaseType(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async updateReleaseType({ commit }, content) {
      //单个修改放行类别
      const { data } = await http.updateReleaseType(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    // 物品放行的放行类别 - end
    // ****************
    // 放行原因 - start
    async getReleaseReasons({ commit }) {
      //获取放行原因
      const { data } = await http.getReleaseReasons();
      console.log(data);
      if (data.code === 0) {
        commit("SET_RELEASE_REASON", data.data);
        console.log(data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async createReleaseReasons({ commit }, content) {
      //单个添加放行原因
      const { data } = await http.createReleaseReasons(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async deleteReleaseReasons({ commit }, content) {
      //单个删除放行原因
      const { data } = await http.deleteReleaseReasons(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async updateReleaseReasons({ commit }, content) {
      //单个修改放行原因
      const { data } = await http.updateReleaseReasons(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    // 放行原因 - end
    // ****************
    // 账号管理 - start
    async getAccount({ commit }) {
      //获取账号信息
      const { data } = await http.getAccount();
      console.log(data);
      if (data.code === 0) {
        commit("SET_ACCOUNT", data.data);
        console.log(data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async createAccount({ commit }, content) {
      //单个添加账号信息
      const { data } = await http.createAccount(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async deleteAccount({ commit }, content) {
      //单个删除账号信息
      const { data } = await http.deleteAccount(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async updateAccount({ commit }, content) {
      //单个修改账号信息
      const { data } = await http.updateAccount(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    // 账号管理 - end
    // ****************
    async searchRecord({ commit }, content) {
      const { data } = await http.searchRecord(content);
      if (data.code === 0) {
        commit("SET_RECORD_RESERVE", data.data);
        console.log(data.data);
      } else {
        commit("SET_DATA", data.data);
      }
    },
    async deleteRecord({ commit }, content) {
      //单个预约记录
      const { data } = await http.deleteRecord(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },

    async searchStaffRecord({ commit }, content) {
      const { data } = await http.searchStaffRecord(content);
      if (data.code === 0) {
        commit("SET_RECORD_STAFF_PASS", data.data);
        console.log(data.data);
      } else {
        commit("SET_DATA", data.data);
      }
    },
    async deleteStaffRecord({ commit }, content) {
      //单个预约记录
      const { data } = await http.deleteStaffRecord(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },

    async searchVisitorRecord({ commit }, content) {
      const { data } = await http.searchVisitorRecord(content);
      if (data.code === 0) {
        commit("SET_RECORD_VISITOR_PASS", data.data);
        console.log(data.data);
      } else {
        commit("SET_DATA", data.data);
      }
    },
    async deleteVisitorRecord({ commit }, content) {
      //单个预约记录
      const { data } = await http.deleteVisitorRecord(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },

    async searchReleaseRecord({ commit }, content) {
      const { data } = await http.searchReleaseRecord(content);
      if (data.code === 0) {
        commit("SET_RECORD_RESERVE", data.data);
        console.log(data.data);
      } else {
        commit("SET_DATA", data.data);
      }
    },

    async deleteReleaseRecord({ commit }, content) {
      //单个预约记录
      const { data } = await http.deleteReleaseRecord(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },

    async getRegion({ commit }) {
      //获取门禁配置
      const { data } = await http.getRegion();
      if (data.code === 0) {
        commit("SET_GET_REGION", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },
    // async getInvite({commit}, content) {
    //     const {data} = await http.getInvite(content);
    //     if (data.code === 0) {
    //         commit('SET_GET_INVITE', data.data);
    //     } else {
    //         commit('SET_DATA', data);
    //     }
    // },
    async getArrive({ commit }, content) {
      //获取访客到访记录
      const { data } = await http.getArrive(content);
      if (data.code === 0) {
        commit("SET_GET_ARRIVE", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },
    // async staffData({commit}) {
    //     const {data} = await http.staffData();
    //     commit('SET_DATA', data);
    // },
    // async menuData({commit}) {
    //     const {data} = await http.menuData();
    //     commit('SET_DATA', data);
    // },
    // async changePassword({commit}, content) {
    //     const {data} = await http.changePassword(content);
    //     commit('SET_DATA', data);
    // },

    async getSystem({ commit }, content) {
      //获取邀请记录
      const { data } = await http.getSystem(content);
      commit("SET_SYSTEM", data.data);
    },
    async changeSystem({ commit }, content) {
      //修改配置信息
      const { data } = await http.changeSystem(content);
      commit("SET_DATA", data);
    },
    async deleteRegion({ commit }, content) {
      const { data } = await http.deleteRegion(content);
      commit("SET_DATA", data);
    },
    async getPort({ commit }) {
      const { data } = await http.getPort();
      if (data.code === 0) {
        commit("SET_GET_PORT", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },
    // async createRegion({commit}, content) {
    //     const {data} = await http.createRegion(content);
    //     commit('SET_DATA', data);
    // },
    // async updateRegion({commit}, content) {
    //     const {data} = await http.updateRegion(content);
    //     commit('SET_DATA', data);
    // },
    async searchInvite({ commit }, content) {
      const { data } = await http.searchInvite(content);
      if (data.code === 0) {
        commit("SET_GET_INVITE", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },

    /**
     *
     * @date 2022-03-09 16:23
     * 获取部门信息
     * 参数：
     *  select_key：查询条件
     *  select_value：查询的内容
     *  page：页数
     * 返回
     *  code： 返回的状态值 0：返回成功，-1：返回失败，-2：系统未登录
     *  msg：提示信息
     *  data：数据集合
     *      key: 返回的变量名称
     *      $key： 数据集合
     *      total：数据总数
     **/
    async getDepartment({ commit }, content) {
      //
      const { data } = await http.getDepartment(content);
      if (data.code === 0) {
        commit("SET_DATA_INFO", data);
      } else {
        commit("SET_DATA", data);
      }
    },

    /**
     * 获取员工信息
     **/
    async searchStaff({ commit }, content) {
      //查找指定员工数据
      const { data } = await http.searchStaff(content);
      if (data.code === 0) {
        commit("SET_DATA_INFO", data);
      } else {
        commit("SET_DATA", data);
      }
    },

    /**
     * 来访事由
     * start
     **/
    async getReasons({ commit }, content) {
      // 获取来访事由
      const { data } = await http.getReasons(content);
      // console.log(data);
      if (data.code === 0) {
        commit("SET_DATA_INFO", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async createReasons({ commit }, content) {
      //单个添加来访事由
      const { data } = await http.createReasons(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async deleteReasons({ commit }, content) {
      //单个删除来访事由
      const { data } = await http.deleteReasons(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async updateReasons({ commit }, content) {
      //单个修改来访事由
      const { data } = await http.updateReasons(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    /**
     * 来访事由
     * end
     **/

    // 拜访公司 - start
    // async getArea({ commit }) {
    //   //获取拜访公司
    //   const { data } = await http.getArea();
    //   // console.log(data);
    //   if (data.code === 0) {
    //     commit("SET_DATA_INFO", data);
    //     // console.log(data);
    //   } else {
    //     commit("SET_DATA", data);
    //   }
    // },
    // async createArea({ commit }, content) {
    //   //单个添加拜访公司
    //   const { data } = await http.createArea(content);
    //   if (data.code === 0) {
    //     commit("SET_DATA", data);
    //   } else {
    //     commit("SET_DATA", data);
    //   }
    // },
    // async deleteArea({ commit }, content) {
    //   //单个删除拜访公司
    //   const { data } = await http.deleteArea(content);
    //   if (data.code === 0) {
    //     commit("SET_DATA", data);
    //   } else {
    //     commit("SET_DATA", data);
    //   }
    // },
    // async updateArea({ commit }, content) {
    //   //单个修改拜访公司
    //   const { data } = await http.updateArea(content);
    //   if (data.code === 0) {
    //     commit("SET_DATA", data);
    //   } else {
    //     commit("SET_DATA", data);
    //   }
    // },
    // 拜访公司 - end
    // 拜访区域 - start
    async getDevice({ commit }) {
      //
      const { data } = await http.getDevice();
      // console.log(data);
      if (data.code === 0) {
        commit("SET_DEVICE", data.data);
        commit("SET_DATA_INFO", data);
        // console.log(data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async createDevice({ commit }, content) {
      //
      const { data } = await http.createDevice(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async deleteDevice({ commit }, content) {
      //
      const { data } = await http.deleteDevice(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async updateDevice({ commit }, content) {
      //
      const { data } = await http.updateDevice(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    // 拜访区域 - end

    // 题目信息
    async getTimu({ commit }) {
      //
      const { data } = await http.getTimu();
      // console.log(data);
      if (data.code === 0) {
        commit("SET_DATA_INFO", data);
        // console.log(data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async createTimu({ commit }, content) {
      //
      const { data } = await http.createTimu(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async deleteTimu({ commit }, content) {
      //
      const { data } = await http.deleteTimu(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async updateTimu({ commit }, content) {
      //
      const { data } = await http.updateTimu(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },

    async get_corp_usr({ commit }) {
      //
      const { data } = await http.get_corp_usr();
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },

    // 工作流程 - start
    async getWorkflow({ commit }, content) {
      //获取工作流程
      const { data } = await http.getWorkflow(content);
      console.log(data);
      if (data.code === 0) {
        commit("SET_DATA_INFO", data);

        //   console.log(data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async createWorkflow({ commit }, content) {
      //单个添加工作流程
      const { data } = await http.createWorkflow(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async deleteWorkflow({ commit }, content) {
      //单个删除工作流程
      const { data } = await http.deleteWorkflow(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async updateWorkflow({ commit }, content) {
      //单个修改工作流程
      const { data } = await http.updateWorkflow(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async getWorkflowList({ commit }, content) {
      //获取工作流程
      const { data } = await http.getWorkflowList(content);
      console.log(data);
      if (data.code === 0) {
        commit("SET_DATA_INFO", data);

        //   console.log(data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async createWorkflowList({ commit }, content) {
      //单个添加工作流程
      const { data } = await http.createWorkflowList(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async deleteWorkflowList({ commit }, content) {
      //单个删除工作流程
      const { data } = await http.deleteWorkflowList(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async updateWorkflowList({ commit }, content) {
      //单个修改工作流程
      const { data } = await http.updateWorkflowList(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    // 工作流程 - end
    // 主图信息操作
    async getMainPhoto({ commit }, content) {
      //获取部门数据
      const { data } = await http.getMainPhoto(content);
      if (data.code === 0) {
        commit("SET_MAINPHOTO", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async createMainPhoto({ commit }, content) {
      //单个添加主图信息
      const { data } = await http.createMainPhoto(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async deleteMainPhoto({ commit }, content) {
      //单个删除主图信息
      const { data } = await http.deleteMainPhoto(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    // ****************

    /**
     * 现场登记
     */
    async searchRecordRegister({ commit }, content) {
      const { data } = await http.searchRecordRegister(content);
      if (data.code === 0) {
        commit("SET_RECORD_RESERVE", data.data);
        console.log(data.data);
      } else {
        commit("SET_DATA", data.data);
      }
    },
    async deleteRecordRegister({ commit }, content) {
      const { data } = await http.deleteRecordRegister(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },

    async checkOutRecordRegister({ commit }, content) {
      const { data } = await http.checkOutRecordRegister(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },

    /**
     * 二维码通行
     */
    async searchRecordPass({ commit }, content) {
      const { data } = await http.searchRecordPass(content);
      if (data.code === 0) {
        commit("SET_RECORD_RESERVE", data.data);
        console.log(data.data);
      } else {
        commit("SET_DATA", data.data);
      }
    },
    async deleteRecordPass({ commit }, content) {
      const { data } = await http.deleteRecordPass(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },

    /**
     * 无效通行数据
     */ async searchRecordErrPass({ commit }, content) {
      const { data } = await http.searchRecordErrPass(content);
      if (data.code === 0) {
        commit("SET_RECORD_RESERVE", data.data);
        console.log(data.data);
      } else {
        commit("SET_DATA", data.data);
      }
    },
    async deleteRecordErrPass({ commit }, content) {
      const { data } = await http.deleteRecordErrPass(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    /**
     * 公司信息
     */
    //单获取公司信息
    async getCompany({ commit }, content) {
      //
      const { data } = await http.getCompany(content);
      if (data.code === 0) {
        commit("SET_DATA_INFO", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async createCompany({ commit }, content) {
      //单个添加公司信息
      const { data } = await http.createCompany(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async deleteCompany({ commit }, content) {
      //单个删除公司信息
      const { data } = await http.deleteCompany(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async updateCompany({ commit }, content) {
      //单个修改公司信息
      const { data } = await http.updateCompany(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    /**
     * 应用管理
     * start
     **/
    async getCorp({ commit }, content) {
      const { data } = await http.getCorp(content);
      // console.log(data);
      if (data.code === 0) {
        commit("SET_DATA_INFO", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async createCorp({ commit }, content) {
      //单个添加
      const { data } = await http.createCorp(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async deleteCorp({ commit }, content) {
      //单个删除
      const { data } = await http.deleteCorp(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async updateCorp({ commit }, content) {
      //单个修改
      const { data } = await http.updateCorp(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    /**
     * 组织管理
     * start
     **/
    async getOrganize({ commit }, content) {
      const { data } = await http.getOrganize(content);
      if (data.code === 0) {
        commit("SET_DATA_INFO", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async createOrganize({ commit }, content) {
      //单个添加
      const { data } = await http.createOrganize(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async deleteOrganize({ commit }, content) {
      //单个删除
      const { data } = await http.deleteOrganize(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async updateOrganize({ commit }, content) {
      //单个修改
      const { data } = await http.updateOrganize(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    }
  }
});



// WEBPACK FOOTER //
// ./src/store.js